import React from "react";
import { motion } from "framer-motion";

const Card = ({ image, title, description }) => {
  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="group relative shadow-lg rounded-2xl overflow-hidden bg-white hover:shadow-2xl transition-all duration-300 cursor-pointer"
    >
      {/* Image Container with Overlay */}
      <div className="relative h-64 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
        />
        
        {/* Gradient Overlay - appears on hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            {description && (
              <p className="text-white text-sm font-medium leading-relaxed">
                {description}
              </p>
            )}
          </div>
        </div>

        {/* Shimmer Effect on Hover */}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="shimmer absolute inset-0"></div>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-4 bg-secondary/50 backdrop-blur-sm">
        <h3 className="text-center font-semibold text-primary text-lg group-hover:text-primary-700 transition-colors duration-300">
          {title}
        </h3>
        
        {/* Decorative Line */}
        <div className="mt-2 mx-auto w-0 group-hover:w-16 h-0.5 bg-gradient-primary transition-all duration-300"></div>
      </div>

      {/* Corner Accent */}
      <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-primary opacity-0 group-hover:opacity-20 transition-opacity duration-300" 
           style={{ clipPath: 'polygon(100% 0, 0 0, 100% 100%)' }}>
      </div>
    </motion.div>
  );
};

export default Card;
